<template>
  <select
    class="Select"
    :value="modelValue"
    :required="isRequired"
    @change="handleInput"
  >
    <option
      v-for="(option, i) in options"
      :key="i"
      :value="option.value !== null ? option.value : ''"
      :disabled="option.isDisabled"
    >
      {{ option.label }}
    </option>
  </select>
</template>

<script lang="ts" generic="T" setup>
import { SelectOption } from "@/components/Select.types";

const modelValue = defineModel<T>({
  required: true,
});

defineProps<{
  options: Array<SelectOption<T>>,
  isRequired?: boolean,
}>();

function handleInput (e: Event) {
  const rawValue = (e.target as HTMLSelectElement).value;
  const value = rawValue !== "" ? rawValue : null;

  modelValue.value = value as T;
}
</script>

<style lang="scss" scoped>
.Select {
  width: 100%;

  border: none;
  outline: none;
  background: none;
  appearance: none;

  font: var(--fontWeightNormal) 18px / 1 var(--fontFamilyMono);
  font-variant-ligatures: none;

  &:not(:disabled) {
    cursor: pointer;
  }
}
</style>
